/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/SMSTemplateEditor/Content/SegmentsWarning/Content/Trigger"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventActionDataSmsTemplateContentValueData = fromData.useDataFormat({ viewPath,
context: 'event_action',
path: 'data.sms_template.content',
format: fromHelpers.getCharacterCount,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-HFmAS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-2-HFmAS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event_action.data.sms_template.content"
 format="helpers.js getCharacterCount"
 text={eventActionDataSmsTemplateContentValueData}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 cursor="pointer"
 type="orange"
 style="filled"
 alignSelf="flex-end"
>
{childProps => (
<div
  data-testid="Trigger.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-2-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 height={16}
 width={16}
 fill2="#7C5E0F"
 fill="#7C5E0F"
/>
<TysiaTagText
  viewPath={`${viewPath}/TysiaTagText`}
 color="#7C5E0F"
 text="Over 2 SMS segments"
/>
</div>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}